import { isValidElement } from 'react';
import { Box } from '@chakra-ui/react';

import type { SlotProp } from '../../@types';

type Props = {
  slot?: SlotProp;
  position?: 'top' | 'bottom';
};

/**
 * Render additional element above (top) or below (bottom) the selected payment
 * method's form.
 * @prop {SlotProp} slot React component to render above or below the payment method form.
 * @prop {string} position Position of the slot element (default: top).
 */
export const Slot = ({ slot, position = 'top' }: Props) => {
  if (!slot) return null;

  // Get slot element for given position (default: top)
  const { slot: renderSlot = null, position: renderPosition = 'top' } =
    Array.isArray(slot)
      ? slot.find(el => position === el.position) || {}
      : slot.slot
        ? slot
        : { slot };

  if (!renderSlot || !isValidElement(renderSlot)) return null;

  if (position !== renderPosition) return null;

  return (
    <Box
      paddingTop={renderPosition === 'top' ? 6 : 4}
      className={`PaymentMethodSlot-${renderPosition}`}
    >
      {renderSlot}
    </Box>
  );
};
